import $ from 'jquery';
import Splitter from 'split-html-to-chars';

$(document).ready(function () {
  let els = document.querySelectorAll(".js-splitme");
  [].forEach.call(els, function (el) {
    el.outerHTML = Splitter(el.outerHTML, '<span class="letter">$</span>');
  });
})
